export default "__VITE_ASSET__DoX2DpDb__"